import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { makeStyles, createStyles } from '../../styles';
export const PaperModalHeader = ({ className, children, }) => {
    const classes = useStyles();
    return _jsx("div", Object.assign({ className: cn(classes.root, className) }, { children: children }));
};
const useStyles = makeStyles((theme) => createStyles({
    root: {
        padding: theme.spacing(1, 4),
        paddingTop: 0,
        borderBottom: `1px solid ${theme.divider.primary}`,
    },
}));
export default PaperModalHeader;
//# sourceMappingURL=PaperModalHeader.js.map